import React, { useContext, useEffect, useState } from 'react'
// import { performRequest } from '../../../../common/utils';
import { QueryClient, useQuery } from '@tanstack/react-query';
import MicroModal from 'micromodal';
import { useNavigate } from 'react-router-dom'
import { addManageBillingModalId } from '../MenuTabs/Utils';
import Modal from '../../../common/modal/Modal';
import Button from '../../../common/button/Button';
import ManageBillingModalTable from './ManageBillingModalTable';
import { TeamContext } from '../MenuTabs/MenuTabs';

const ManageBillingModal = ({
  modalOption = 'automatic',
  isAdmin = false,
  teamTitle = '',
  teamId,
  refetchAdded = null, 
  refetchInvited = null,
  navigateTo = '',
  data
}) => {

  const modalId = addManageBillingModalId(teamId)
  const queryClient = new QueryClient()
  const [subtotal, setSubTotal] = useState(0)
  const [variationId, setVariationId] = useState(0)
  const [modifyPlan, setModifyPlan] = useState(false)
  const [isSavingPlan, setIsSavingPlan] = useState(false)
  const [isProcessingPlan, setIsProcessingPlan] = useState(false)
  const [isCancellingPlan, setIsCancellingPlan] = useState(false)
  const [seatToAssign, setSeatToAssign] = useState([])
  const [seatToRenew, setSeatToRenew] = useState([])
  const [additionalSeatSummary, setAdditionalSeatSummary] = useState(0)
  const { refetchTeamData } = useContext(TeamContext);

  // useEffect(() => {
  //   refetch()
  // }, [])

  const saveNewPlan = async () => {
    const newSubscriptionId = tangibleFields.store.getValue('msync-org-select-new-plan')
    await manageBilling('save', newSubscriptionId)
    setVariationId(newSubscriptionId)
    setIsSavingPlan(false)
  }

  const processNewPlan = async () => {
    await manageBilling('process')
    setIsProcessingPlan(false)
    MicroModal.close(modalId)
    refetchTeamData()
  }

  useEffect( () => {
    if ( isSavingPlan ) {
      saveNewPlan()
    } else if ( isProcessingPlan ) {
      processNewPlan()
    }
  }, [isSavingPlan, isProcessingPlan])

  // const { 
  //   isLoading,
  //   isFetching,
  //   isError,
  //   error,
  //   refetch,
  //   data } = useQuery({
  //     queryKey: ['msync_org_plan_datas'],
  //     queryFn: request,
  //     refetchOnWindowFocus: false,
  //     enabled: false
  //   }, queryClient)

  // async function request(){
  //   const currentRestUrl = window.group_dashboard.base
  //   const nonce = window.group_dashboard.nonce

  //   const url = currentRestUrl + 'membersync/licensing/v1/org/' + teamId + '/plans/datas'
  //   try {
  //     const res = await fetch(url, {
  //         method: 'GET',
  //         headers:{
  //           'X-WP-Nonce': nonce,
  //           'Content-type': 'application/json'
  //         }
  //     })
  //     const resultJSON = await res.json()
  //     return resultJSON.response

  //   } catch (error) {
  //     console.error( error )
  //     return false
  //   }
  // }

  async function cancelPlan(){
    const currentRestUrl = window.group_dashboard.base
    const nonce = window.group_dashboard.nonce

    const url = currentRestUrl + 'membersync/licensing/v1/organization/' + teamId + '/plan/cancel'
    try {
      const res = await fetch(url, {
        method: 'POST',
        body: JSON.stringify({
          'currentPlan' : data.current_plan
        }),
        headers:{
          'X-WP-Nonce': nonce,
          'Content-type': 'application/json'
        }
      })
      const resultJSON = await res.json()
      return resultJSON.response
    } catch (error) {
      console.error( error )
      return false
    }
  }

  const [additionalSeats, setAdditionalSeats] = useState(0)

  useEffect(() => {
    setAdditionalSeats(data?.current_plan.additional_seat_quantity ? data?.current_plan.additional_seat_quantity : data?.infos.seatMinOrder)
  }, [data?.infos.seatMinOrder])

  const handleCloseModal = (modalName) => {
    MicroModal.close(modalName)
  }

  const manageBilling = async ( type, newVariationId ) => {
    const currentRestUrl = window.group_dashboard.base
    const nonce = window.group_dashboard.nonce

    let currentVariationId = variationId === 0 ? newVariationId : variationId
    if ( !currentVariationId ) currentVariationId = data.current_plan.id ?? 0

    const url = currentRestUrl + 'membersync/licensing/v1/org/' + teamId + '/variation/' + currentVariationId + '/edit'

    let currentQuantity = 0
    if ( data?.current_plan.additional_seat ) {
      currentQuantity = data?.current_plan.additional_seat ? 
        parseInt(data?.current_plan.total) + parseInt(data?.current_plan.additional_seat_quantity ?? 0) 
        : parseInt(data?.current_plan.total)
    }

    let quantity = data?.plans[currentVariationId]?.total ?? 0
    let additionalSeat = data?.plans[currentVariationId]?.additional_seat ?? 0

    let addToCart = false

    if ( data.current_plan.id ) {
      if ( variationId !== data.current_plan.id ) addToCart = true
    }

    if ( additionalSeats !== 0 ) addToCart = true

    try {
      const res = await fetch(url, {
        method: 'POST',
        body: JSON.stringify({
          subscription: data.current_plan.subscription_id,
          product: data.current_plan.product_id,
          current_quantity: currentQuantity,
          quantity: quantity,
          variation_quantity: 1,
          additional_seat: additionalSeat,
          seat_to_assign: seatToAssign,
          seat_to_renew: seatToRenew,
          type: type,
          total: subtotal,
          additional_seats: additionalSeats,
          add_to_cart: addToCart
        }),
        headers:{
          'X-WP-Nonce': nonce,
          'Content-type': 'application/json'
        }
      })
      const resultJSON = await res.json()
      if ( resultJSON.response?.subtotal ) setSubTotal( resultJSON.response.subtotal )
      if ( type === 'process' && resultJSON.response?.redirectURL ) window.location = resultJSON.response.redirectURL
      // return resultJSON.response
    } catch (error) {
      console.error( error )
      return false
    }
  }

  const getPlanComboBoxChoices = () => {

    if ( !data ) return []

    return data.choices
  }

  const customPlanChoices = getPlanComboBoxChoices()

  function getMaxSeatsNumber() {
    let maxSeatsNumber = 0

    if ( data?.subscription ) {
      maxSeatsNumber = data?.current_plan.total + ( data?.current_plan.additional_seat_quantity ? parseInt(data?.current_plan.additional_seat_quantity) : 0 )
    } else {
      maxSeatsNumber = data?.infos.seatNumbers
    }
    
    return maxSeatsNumber
  }

  const modalIdConfirmation = modalId + '-confirmation'

  // console.log('data : ', data)

  return (
    <>
      <Modal 
        modalId={modalId} 
        buttonTitle="" 
        modalClassNames={ 'msync-manage-billing-custom-modal msync-manage-billing-custom-modal-border'}
        modalHeading="Manage billing"
      >
        <main className="msync-modal__body">
              {/* {
                isError
                ? <div className='msync-save-members-response error'><span>{ error.message }</span></div>
                : saveMemberResponse && <div className='msync-save-members-response error'><span>{ saveMemberResponse }</span></div>
              } */}
            <div className="msync-modal-content-section">
                <div key={''} className="msync-form">
                  <div className="msync-form__row">
                      {/* <div className="msync-form__col"> */}
                          <div className="msync-form__group">
                            <span className='msync-form__users-title'>Your organization { data?.subscription ? 'plan' : 'seats' }</span>
                            <div className="msync-form__row">
                              { data?.subscription ? <div className='msync-current-plan-contents'>
                                <div className='msync-current-plan-infos'>
                                  <div className='msync-current-plan-name'>
                                    { data?.current_plan.name }
                                  </div>
                                  <div className='msync-current-plan-quantity'>
                                    { 
                                      data?.current_plan.additional_seat_quantity ? 
                                        data?.current_plan.total + ' + ' + data?.current_plan.additional_seat_quantity + ' seats' 
                                        : data?.current_plan.total + ' seats'
                                    }
                                  </div>
                                </div>
                                <div className='msync-current-plan-modify-plan'>
                                  { 
                                    data?.current_plan.name && <button
                                      type="button"
                                      className='msync-button'
                                      onClick={() => {
                                        setModifyPlan(true)
                                      }}
                                    >
                                      Modify plan
                                    </button>
                                  }
                                  {
                                    data?.current_plan.name && <Button
                                      className="msync-button--is-style-outline msync-button--is-theme-destructive"
                                      type="button"
                                      name="Cancel"
                                      onClick={ () => MicroModal.show(modalIdConfirmation) }
                                      aria-label="Close this dialog window"
                                    />
                                  }
                                </div>
                              </div> 
                                : <div className='msync-current-plan-contents'>
                                    <div className='msync-current-plan-infos'>
                                      <div className='msync-current-plan-name'>
                                        { data?.infos.seatTypeName }
                                      </div>
                                      <div className='msync-current-plan-quantity'>
                                        { data?.infos.seatNumbers } seats
                                      </div>
                                    </div>
                                 </div>
                              }
                              <div className='msync-current-plan-contents'>
                                <div className='msync-current-plan-infos'>
                                  <div className='msync-current-plan-name'>
                                    { data?.infos.seatTypeName } Availability
                                  </div>
                                  <div className='msync-current-plan-quantity'>
                                    { data?.infos.seatAssignedCount }/{ getMaxSeatsNumber() } used
                                  </div>
                                </div>
                              </div>
                              { data?.subscription ? <div className='msync-current-plan-contents'>
                                <div className='msync-current-plan-infos'>
                                  <div className='msync-current-plan-name'>
                                    Subscription term details
                                  </div>
                                  <div className='msync-current-plan-quantity'>
                                    {
                                      data?.current_plan.status === 'active' ? 
                                        'Renews' : 'Finished'
                                    } on { data?.current_plan.next_payment }
                                  </div>
                                </div>
                              </div> : '' }
                            </div>
                          </div>
                      {/* </div> */}
                  </div>
                  <div className="msync-form__row">
                    { 
                      modifyPlan && customPlanChoices.length !== 0 && tangibleFields.render({
                        name: 'msync-org-select-new-plan',
                        type: 'combo-box',
                        choices: customPlanChoices
                      })
                    }
                    { 
                      modifyPlan && <button
                        type="button"
                        className='msync-button'
                        disabled={ isSavingPlan }
                        onClick={() => {
                          setIsSavingPlan(true)
                        }}
                      >
                        Save
                      </button>
                    }
                    { 
                      modifyPlan && <button
                        type="button"
                        className='msync-button msync-button--is-style-outline msync-button--is-theme-destructive'
                        onClick={() => {
                          setModifyPlan(false)
                          setSubTotal(0)
                        }}
                      >
                        Cancel
                      </button>
                    }
                  </div>
                  {
                    data?.current_plan.additional_seat ? <div className="msync-form__row">
                      <div>
                        { data?.infos.seatTypeName }
                      </div>
                      <div>
                        { data?.current_plan.total }
                      </div>
                      <div>
                        <input 
                          type="number"
                          min={data?.infos.seatMinOrder}
                          value={additionalSeats}
                          onChange={(e) => {
                            setAdditionalSeats(e.target.value)
                          }}
                        />
                      </div>
                      <div>
                        { data?.infos.seatPrice }
                      </div>
                      <div>
                        <Button
                          className="msync-button--is-style-outline"
                          type="button"
                          name="Update seat count"
                          onClick={ () => {
                            let newSubtotal = subtotal + ( additionalSeats * data.infos.seatPrice )
                            setSubTotal(newSubtotal)
                            setAdditionalSeatSummary(additionalSeats)
                          }}
                        />
                      </div>
                    </div> : ''
                  }
                  <div>
                    {
                      data?.members ? <ManageBillingModalTable 
                          membersData={data}
                          setSeatToRenew={( memberId, value ) => {
                            let currentSeatToRenew = seatToRenew
                            currentSeatToRenew[memberId] = value
                            setSeatToRenew(currentSeatToRenew)
                          }}
                          setSeatToAssign={( memberId, value ) => {
                            let currentSeatToAssign = seatToAssign
                            currentSeatToAssign[memberId] = value
                            setSeatToAssign(currentSeatToAssign)
                          }}
                        /> : ''
                    }
                  </div>
                  <div className="msync-form__row">
                    <div className="msync-form__col">
                      <div className="msync-form__group">
                        Order Summary
                      </div>
                      {
                        additionalSeatSummary !== 0 ? <div>
                          Additional { data.infos.seatTypeName } seats X { additionalSeatSummary } { additionalSeatSummary * data.infos.seatPrice }
                        </div> : ''
                      }
                      <div className="msync-form__group">
                        Subtotal : { subtotal }
                      </div>
                      <div className="msync-form__group">
                        Total : { subtotal }
                      </div>
                    </div>
                  </div>
                  <div className="msync-form__footer">
                  </div>
                </div>
            </div>
          <footer className="modal__footer">
            <Button
              className="msync-button--is-style-outline msync-button--is-theme-destructive"
              type="button"
              name="Cancel"
              onClick={ () => handleCloseModal(modalId) }
              aria-label="Close this dialog window"
            />
            <Button
              className="msync-primary-btn"
              isDisabled={ isProcessingPlan }
              onClick={ () => {
                setIsProcessingPlan(true)
                // handleCloseModal(modalId)
              }}
              name="Process plan modification"
            />
          </footer>
        </main>
      </Modal>
      <Modal
        modalId={modalIdConfirmation} 
        buttonTitle="" 
        modalClassNames={ 'msync-manage-billing-custom-modal msync-manage-billing-custom-modal-border'}
        modalHeading="Confirmation"
      >
        <main className="msync-modal__body">
          Are you sure you want to cancel your plan ?
          <footer className="modal__footer">
            <Button
              className="msync-button--is-style-outline msync-button--is-theme-destructive"
              type="button"
              name="Cancel"
              isDisabled={isCancellingPlan}
              onClick={ () => MicroModal.close(modalIdConfirmation) }
              aria-label="Close this dialog window"
            />
            <Button
              className="msync-primary-btn"
              onClick={ async () => {
                setIsCancellingPlan(true)
                await cancelPlan()
                setIsCancellingPlan(false)
                refetchTeamData()
              }}
              isDisabled={isCancellingPlan}
              name={isCancellingPlan ? 'Loading ...' : 'Remove'}
            />
          </footer>
        </main>
      </Modal>
    </>
  )
}

export default ManageBillingModal
